// A membership sold anywhere (the sell dialog is the app's one, opened from Memberships or a
// customer's record): the lists showing memberships hear it and read again (QA-531: Members kept
// saying "No members yet." until a reload).

const listeners = new Set<() => void>();

/** Hear every sale until the returned function is called (a React effect's cleanup). */
export function onMembershipSold(fn: () => void): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}

/** The sell dialog says a membership was sold. */
export function membershipSold(): void {
  for (const fn of [...listeners]) fn();
}
